/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedLegalRouteImport } from './routes/_authenticated/legal'
import { Route as AuthenticatedGettingStartedRouteImport } from './routes/_authenticated/getting-started'
import { Route as AuthenticatedFinanceRouteImport } from './routes/_authenticated/finance'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedGamesIndexRouteImport } from './routes/_authenticated/games/index'
import { Route as AuthenticatedGamesAddRouteImport } from './routes/_authenticated/games/add'
import { Route as AuthenticatedGamesGameIdRouteImport } from './routes/_authenticated/games/$gameId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideRoute = GuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLegalRoute = AuthenticatedLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGettingStartedRoute =
  AuthenticatedGettingStartedRouteImport.update({
    id: '/getting-started',
    path: '/getting-started',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceRoute = AuthenticatedFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGamesIndexRoute = AuthenticatedGamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGamesAddRoute = AuthenticatedGamesAddRouteImport.update({
  id: '/games/add',
  path: '/games/add',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGamesGameIdRoute =
  AuthenticatedGamesGameIdRouteImport.update({
    id: '/games/$gameId',
    path: '/games/$gameId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/guide': typeof GuideRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/account': typeof AuthenticatedAccountRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/finance': typeof AuthenticatedFinanceRoute
  '/getting-started': typeof AuthenticatedGettingStartedRoute
  '/legal': typeof AuthenticatedLegalRoute
  '/support': typeof AuthenticatedSupportRoute
  '/games/$gameId': typeof AuthenticatedGamesGameIdRoute
  '/games/add': typeof AuthenticatedGamesAddRoute
  '/games': typeof AuthenticatedGamesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/guide': typeof GuideRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/account': typeof AuthenticatedAccountRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/finance': typeof AuthenticatedFinanceRoute
  '/getting-started': typeof AuthenticatedGettingStartedRoute
  '/legal': typeof AuthenticatedLegalRoute
  '/support': typeof AuthenticatedSupportRoute
  '/games/$gameId': typeof AuthenticatedGamesGameIdRoute
  '/games/add': typeof AuthenticatedGamesAddRoute
  '/games': typeof AuthenticatedGamesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/guide': typeof GuideRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/finance': typeof AuthenticatedFinanceRoute
  '/_authenticated/getting-started': typeof AuthenticatedGettingStartedRoute
  '/_authenticated/legal': typeof AuthenticatedLegalRoute
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_authenticated/games/$gameId': typeof AuthenticatedGamesGameIdRoute
  '/_authenticated/games/add': typeof AuthenticatedGamesAddRoute
  '/_authenticated/games/': typeof AuthenticatedGamesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/guide'
    | '/login'
    | '/signup'
    | '/account'
    | '/analytics'
    | '/dashboard'
    | '/finance'
    | '/getting-started'
    | '/legal'
    | '/support'
    | '/games/$gameId'
    | '/games/add'
    | '/games'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/guide'
    | '/login'
    | '/signup'
    | '/account'
    | '/analytics'
    | '/dashboard'
    | '/finance'
    | '/getting-started'
    | '/legal'
    | '/support'
    | '/games/$gameId'
    | '/games/add'
    | '/games'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/guide'
    | '/login'
    | '/signup'
    | '/_authenticated/account'
    | '/_authenticated/analytics'
    | '/_authenticated/dashboard'
    | '/_authenticated/finance'
    | '/_authenticated/getting-started'
    | '/_authenticated/legal'
    | '/_authenticated/support'
    | '/_authenticated/games/$gameId'
    | '/_authenticated/games/add'
    | '/_authenticated/games/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuideRoute: typeof GuideRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide': {
      id: '/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof GuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/legal': {
      id: '/_authenticated/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof AuthenticatedLegalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/getting-started': {
      id: '/_authenticated/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof AuthenticatedGettingStartedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance': {
      id: '/_authenticated/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AuthenticatedFinanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/games/': {
      id: '/_authenticated/games/'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof AuthenticatedGamesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/games/add': {
      id: '/_authenticated/games/add'
      path: '/games/add'
      fullPath: '/games/add'
      preLoaderRoute: typeof AuthenticatedGamesAddRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/games/$gameId': {
      id: '/_authenticated/games/$gameId'
      path: '/games/$gameId'
      fullPath: '/games/$gameId'
      preLoaderRoute: typeof AuthenticatedGamesGameIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedFinanceRoute: typeof AuthenticatedFinanceRoute
  AuthenticatedGettingStartedRoute: typeof AuthenticatedGettingStartedRoute
  AuthenticatedLegalRoute: typeof AuthenticatedLegalRoute
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedGamesGameIdRoute: typeof AuthenticatedGamesGameIdRoute
  AuthenticatedGamesAddRoute: typeof AuthenticatedGamesAddRoute
  AuthenticatedGamesIndexRoute: typeof AuthenticatedGamesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedFinanceRoute: AuthenticatedFinanceRoute,
  AuthenticatedGettingStartedRoute: AuthenticatedGettingStartedRoute,
  AuthenticatedLegalRoute: AuthenticatedLegalRoute,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedGamesGameIdRoute: AuthenticatedGamesGameIdRoute,
  AuthenticatedGamesAddRoute: AuthenticatedGamesAddRoute,
  AuthenticatedGamesIndexRoute: AuthenticatedGamesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuideRoute: GuideRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
